export const SuccessTooltip = () => {
	return (
		<div data-svg-wrapper>
			<svg
				width="56"
				height="56"
				viewBox="0 0 56 56"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect
					x="4"
					y="4"
					width="48"
					height="48"
					rx="24"
					fill="#D1FADF"
				/>
				<rect
					x="4"
					y="4"
					width="48"
					height="48"
					rx="24"
					stroke="#ECFDF3"
					strokeWidth="8"
				/>
				<path
					d="M28 18L31.09 24.26L38 25.27L33 30.14L34.18 37.02L28 33.77L21.82 37.02L23 30.14L18 25.27L24.91 24.26L28 18Z"
					stroke="#039855"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</div>
	);
};
